import VueSweetalert2 from 'vue-sweetalert2'
import Vue from 'vue'

Vue.use(VueSweetalert2)

export default class Api {
  /**
   * Requete api pour les formulaire
   * @param {Object} vue : vue model
   * @param {Function} fn : fonction de type api à appeler
   * @param {Object} apiOptions : options http pour la fonction api
   *                                  * {array} get: paramètres get pour la requete
   *                                  * {object} post : données post
   *                                  * {object} options : si besoin passez ici des paramètres comme fullLoader (active le loader global durant la requete)
   *                                  * {function} successCb: fonction de callback en cas de succès
   * @param {Object} alertOptions : options pour sweetalert
   *                                  * {string} successTitle: titre du popup de success si différent de celui par défaut
   *                                  * {string} successText: texte du popup de success si besoin
   *                                  * {function} successCb: fonction de callback pour le popup de success après avoir validé
   *                                  * {string} errorTitle: titre du popup d'erreur si différent de celui par défaut
   *                                  * {string} errorText: texte du popup d'erreur si besoin
   *                                  * {function} errorCb: fonction de callback pour le popup d'erreur après avoir validé
   * @return promise vue-resource
   */
  static form (vue, fn, apiOptions, swalOptions = {}) {
    apiOptions.$http = vue.$http
    return fn(apiOptions).then((response) => {
      let success = response && response.ok && response.data.success
      if (success) {
        Vue.swal({
          title: (swalOptions.successTitle) ? (swalOptions.successTitle) : 'form.response.success',
          html: (swalOptions.successText) ? (swalOptions.successText) : '',
          type: 'success'
        }).then(function () {
          if (swalOptions.successCb) {
            swalOptions.successCb(response.data)
          }
        })
      } else {
        let text = (swalOptions.errorText) ? swalOptions.errorText : ''
        if (!response.data) {
          text = 'api.internal'
        } else if (response.data.message) {
          text = response.data.message
        } else if (response.data.errors) {
          text = generateErrors(response.data.errors)
        }
        Vue.swal({
          title: (swalOptions.errorTitle) ? (swalOptions.errorTitle) : 'form.response.error',
          html: text,
          type: 'error'
        }).then(function () {
          if (swalOptions.errorCb) {
            swalOptions.errorCb(response.data)
          }
        })
      }
    })
  }
  /**
   * Requete api pour les actions (pas de popup en cas de succès)
   * @param {Object} vue : vue model
   * @param {Function} fn : fonction de type api à appeler
   * @param {Object} apiOptions : options http pour la fonction api
   *                                  * {array} get: paramètres get pour la requete
   *                                  * {object} post : données post
   *                                  * {object} options : si besoin passez ici des paramètres comme fullLoader (active le loader global durrant la requete)
   *                                  * {function} successCb: fonction de callback en cas de succès
   * @param {Object} alertOptions : options pour sweetalert
   *                                  * {string} errorTitle: titre du popup d'erreur si différent de celui par défaut
   *                                  * {string} serrorext: texte du popup d'erreur si besoin
   *                                  * {function} errorCb: fonction de callback pour le popup d'erreur après avoir validé
   * @return promise vue-resource
   */
  static action (vue, fn, apiOptions = {}, swalOptions = {}) {
    apiOptions.$http = vue.$http
    return fn(apiOptions).then((response) => {
      if (!response.hasOwnProperty('success')) {
        response.success = response && response.ok && response.data.success
      }
      if (response.success) {
        return response
      } else {
        let text = (swalOptions.errorText) ? swalOptions.errorText : ''
        if (!response.data) {
          text = 'api.internal'
        } else if (response.data.message) {
          text = response.data.message
        } else if (response.data.errors) {
          text = generateErrors(response.data.errors)
        }
        Vue.swal({
          title: (swalOptions.errorTitle) ? (swalOptions.errorTitle) : 'form.response.error',
          html: text,
          type: 'error'
        })
        /* .then(function () {
          if (swalOptions.errorCb) {
            swalOptions.errorCb(response.data)
          }
        }) */
        return response
      }
    })
  }
}

const generateErrors = (errors) => {
  let ul = document.createElement('ul')
  ul.classList.add('swal-errors')
  for (let field in errors) {
    let fieldErrors = errors[field]
    for (let errorKey in fieldErrors) {
      let error = fieldErrors[errorKey]
      let li = document.createElement('li')
      li.innerHTML = error
      ul.appendChild(li)
    }
  }
  return ul.outerHTML
}



// WEBPACK FOOTER //
// ./src/api/api.js